export const buildPatchParams = (otherParams = {}) => {
  const patchParams = {
    data: {
      id: otherParams.id,
      type: 'phase_item',
      attributes: {},
      relationships: {},
    },
  }

  if (otherParams.status) {
    patchParams.data.attributes.status = otherParams.status
  }

  if (otherParams.response) {
    patchParams.data.attributes.response = otherParams.response
  }

  // add additional modifiable relationship values or attributes here!

  return patchParams
}
